import { h } from 'preact';
import clsx from 'clsx';
import { useEffect, useRef, useState } from 'preact/hooks';
import { useGallery } from './product-gallery-context';
import IconPlay from '../utils/icon/play.svg';
import IconPause from '../utils/icon/pause.svg';
import { useWindowSize } from '../utils/window-size';

export default ({
  videoData,
  classNames,
  isActive
}) => {
  const { isMobile } = useWindowSize();
  const source = videoData?.sources[0]?.url;
  const { width, height } = source

  const videoRef = useRef(null);
  const {
    registerVideoRef,
    handleVideoPlay,
    handleVideoPause,
    toggleVideo,
    playingVideoIds,
  } = useGallery();
  const [isPlaying, setIsPlaying] = useState(false);
  const videoId = videoData?.id;

  useEffect(() => {
    const videoEl = videoRef?.current;
    if (!videoId || !videoEl) return null;

    registerVideoRef(videoId, videoEl);

    const onPlay = () => handleVideoPlay(videoId);
    const onPause = () => handleVideoPause(videoId);

    videoEl.addEventListener('play', onPlay);
    videoEl.addEventListener('pause', onPause);
    videoEl.addEventListener('ended', onPause);

    return () => {
      videoEl.removeEventListener('play', onPlay);
      videoEl.removeEventListener('pause', onPause);
      videoEl.removeEventListener('ended', onPause);
    };
  }, [videoId, videoRef.current]);

  useEffect(() => {
    setIsPlaying(playingVideoIds.has(videoId));

    return null;
  }, [playingVideoIds]);

  useEffect(() => {
    if (isActive) {
      videoRef?.current?.play();
    } else {
      videoRef?.current?.pause();
    }
    return null;
  }, [isActive]);

  const togglePlayback = () => {
    if (!videoId) return;

    toggleVideo(videoId);
  };

  return (source &&
    <div className='relative w-full h-full'>
      <video
        ref={videoRef}
        width={width}
        height={height}
        className={clsx(
          classNames, 
          'w-full h-full object-contain',
        )}
        muted
        playsInline
        src={source}
      />
      {isMobile && videoRef.current && (
        <div
          className='bottom-2.5 laptop:bottom-5 justify-end absolute w-full flex pr-2.5 laptop:pr-5'
        >
          <button
            className="bg-white rounded-full h-8 laptop:h-[42px] flex items-center justify-center w-8 laptop:w-[42px]"
            onClick={() => { togglePlayback(); }}
          >
            {isPlaying
              ? <IconPause className="scale-[0.71] laptop:scale-100" />
              : <IconPlay className="scale-[0.71] laptop:scale-100" />
            }
          </button>
        </div>
      )}
    </div>
  )
}